/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Navbar from "../../Navbar";
import Style from "./style";

const ApplicationsLayoutLayout = ({
  children = null,
}) => {
  return (
    <React.Fragment>
      <Navbar goToWebiste />
      <Style>
        {children}
      </Style>
    </React.Fragment>
  );
};

export default ApplicationsLayoutLayout;
